/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

const mutation = gql`
  mutation DownloadDocumentPricingIndividualHealthMutation($input: DownloadDocuments_M_simulation_pricings_individual_healthInput!) {
    downloadDocumentPricingIndividualHealth_M_simulation_pricings_individual_health(input: $input) {
      ok
      error
      
        url 
    }
  }
`;

export default mutation;
